<script lang="ts" setup>
import { Toaster } from 'vue-sonner'

const { loggedIn } = useUserSession()

watch(loggedIn, () => {
  if (!loggedIn.value) {
    navigateTo('/auth/login')
  }
})
</script>

<template>
  <div>
    <Toaster position="top-center" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <UNotifications />
  </div>
</template>
